var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-text-section",
    { attrs: { title: _vm.$t("payment-method.pix") } },
    [
      Object.values(_vm.data.expiresIn).length
        ? _c(
            "emd-text-content",
            { attrs: { title: _vm.$t("expiresIn.title") } },
            [
              _c("div", { staticClass: "eu-inline" }, [
                _vm.data.expiresIn.hours
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tc("expiresIn.hours", _vm.data.expiresIn.hours)
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.data.expiresIn.hours && _vm.data.expiresIn.minutes
                  ? _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("expiresIn.append")) + " "),
                    ])
                  : _vm._e(),
                _vm.data.expiresIn.minutes
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tc(
                              "expiresIn.minutes",
                              _vm.data.expiresIn.minutes
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _c("due-at", { attrs: { dueAt: _vm.data.expiresAt } }),
      _c("discount", { attrs: { data: _vm.data } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }